import React from 'react';
import { FormControl, FormHelperText, InputLabel, MenuItem, Select } from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';
import { ContragentType, ContragentTypeUtil } from '../../../models/enums/contragentType';

interface ContragentTypeFormControlProps {
    name: string;
    label?: string;
    required?: boolean;
    disabled?: boolean;
}

const CONTRAGENT_TYPES = [
    ContragentType.LegalEntity,
    ContragentType.IndividualEntrepreneur,
    ContragentType.SelfEmployed,
];

export const ContragentTypeFormControl: React.FC<ContragentTypeFormControlProps> = ({
    name,
    label = 'Тип контрагента',
    required = true,
    disabled = false,
}) => {
    const { control } = useFormContext();

    return (
        <Controller
            name={name}
            control={control}
            rules={{ required: required ? 'Обязательное поле' : false }}
            render={({ field, fieldState }) => (
                <FormControl fullWidth size="small" error={!!fieldState.error} disabled={disabled} required={required}>
                    <InputLabel
                        required={required}
                        sx={{
                            whiteSpace: 'nowrap',
                            overflow: 'visible',
                            textOverflow: 'clip',
                            maxWidth: 'none',
                        }}
                    >
                        {label}
                    </InputLabel>
                    <Select
                        {...field}
                        label={label}
                        disabled={disabled}
                        required={required}
                        renderValue={(value) => ContragentTypeUtil.getStringValue(value as ContragentType)}
                    >
                        {CONTRAGENT_TYPES.map((type) => (
                            <MenuItem key={type} value={type}>
                                {ContragentTypeUtil.getStringValue(type)}
                            </MenuItem>
                        ))}
                    </Select>
                    {fieldState.error && (
                        <FormHelperText>{fieldState.error.message}</FormHelperText>
                    )}
                </FormControl>
            )}
        />
    );
};
